import { useMemo } from 'react';

import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import { mapInclusion } from '@/v2/components/ui/PackageInclusions';

const usePrependFlightInclusion = <I>(inclusions: I[] | undefined) => {
  const { flightInclusion } = useRoomOptionsData() || {};

  return useMemo(() => {
    if (!flightInclusion) {
      return inclusions;
    }

    const convertedFlightInclusion = mapInclusion(flightInclusion);

    if (!inclusions) {
      return [convertedFlightInclusion];
    }

    return [convertedFlightInclusion, ...inclusions];
  }, [flightInclusion, inclusions]);
};

export default usePrependFlightInclusion;
